import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function EnquiryForm({ type = "General", context = "", compact = false, onDone, testPrefix = "enquiry" }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please complete all required fields.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/enquiries", { ...form, type, context });
      toast.success("Enquiry submitted! We'll be in touch shortly.");
      setForm({ name: "", email: "", phone: "", message: "" });
      onDone && onDone();
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid={`${testPrefix}-form`}>
      <div className={compact ? "space-y-4" : "grid sm:grid-cols-2 gap-4"}>
        <div>
          <Label htmlFor={`${testPrefix}-name`}>Full name *</Label>
          <Input id={`${testPrefix}-name`} value={form.name} onChange={set("name")} className="mt-1.5" data-testid={`${testPrefix}-name`} />
        </div>
        <div>
          <Label htmlFor={`${testPrefix}-email`}>Email *</Label>
          <Input id={`${testPrefix}-email`} type="email" value={form.email} onChange={set("email")} className="mt-1.5" data-testid={`${testPrefix}-email`} />
        </div>
      </div>
      <div>
        <Label htmlFor={`${testPrefix}-phone`}>Phone (optional)</Label>
        <Input id={`${testPrefix}-phone`} value={form.phone} onChange={set("phone")} className="mt-1.5" data-testid={`${testPrefix}-phone`} />
      </div>
      <div>
        <Label htmlFor={`${testPrefix}-message`}>How can we help? *</Label>
        <Textarea id={`${testPrefix}-message`} value={form.message} onChange={set("message")} rows={4} className="mt-1.5" data-testid={`${testPrefix}-message`} />
      </div>
      <Button type="submit" disabled={submitting} className="bg-teal-600 hover:bg-teal-700 rounded-full px-6" data-testid={`${testPrefix}-submit`}>
        {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Send className="w-4 h-4" /> Send enquiry</>}
      </Button>
    </form>
  );
}
